<template>
  <form id="user-form" class="flex flex-col gap-8 w-full">

    <MdnInput
      :disabled="isPreFilled"
      name="cpf"
      :placeholder="isPreFilled ? formated.cpf : 'CPF'"
      type="text"
      errorFeedback="Valor inválido."
      required
      maxlength=14
      mask="999.999.999-99"
      v-on:input="getInputValue"
      :validation="validationCpf"
    />

    <MdnInput
      :disabled="isPreFilled"
      name="msisdn"
      :placeholder="isPreFilled ? formated.msisdn : 'Seu número Claro'"
      type="text"
      errorFeedback="Valor inválido."
      required
      maxlength=16
      v-on:input="getInputValue"
      mask="(99) 9 9999-9999"
      :validation="validationMsisdn"
      />

    <Button :disabled="!isFormValid" id="btn-confirm" @click="send" primary>Continuar</Button>

  </form>
</template>

<script>
import { isEmpty } from 'common/utils'
import { formatMsisdn, formatCpf } from 'common/format'
import { isValidCpf } from '@brazilian-utils/is-valid-cpf'
import { onlyNumbers } from '@brazilian-utils/helper-only-numbers'
import isValidPhone from '@brazilian-utils/is-valid-phone'
import MdnInput from '../../components/MdnInput.vue'
import { setOffer, setChannel, setTelevendasId } from './../../business/offers/store'
import { manageIsTelevendasMixin } from './../../business/televendas/mixins'
import { switchOfferNavigationMixin, backButtonNavigationMixin } from './../../business/navigation/mixins'
import { Button } from 'mondrian-vue'
import { SMS_OFFER_KEY, SMS_MSISDN_KEY, CPF_KEY } from '@/common/constants'

export default {
  name: 'UserForm',
  components: { Button, MdnInput },
  mixins: [manageIsTelevendasMixin, switchOfferNavigationMixin, backButtonNavigationMixin],
  data () {
    return {
      touched: {
        msisdn: false,
        cpf: false
      },
      model: {
        msisdn: '',
        cpf: ''
      },
      preFill: false
    }
  },
  computed: {
    errors () {
      const { model } = this
      return {
        msisdn: isEmpty(model.msisdn) || !isValidPhone(model.msisdn),
        cpf: isEmpty(model.cpf) || !isValidCpf(model.cpf)
      }
    },
    hasError () {
      return Object.values(this.errors).some(Boolean)
    },
    hasTouched () {
      return Object.values(this.touched).every(Boolean)
    },
    formated () {
      return {
        cpf: formatCpf(this.model.cpf),
        msisdn: formatMsisdn(this.model.msisdn)
      }
    },
    isFormValid () {
      const { msisdn, cpf } = this.model
      return (!!msisdn && !!cpf)
    },
    isPreFilled () {
      this.onPrepareData()
      return this.preFill
    }
  },
  methods: {
    send () {
      if (this.hasError && !this.isPreFilled) {
        this.touched.msisdn = true
        this.touched.cpf = true
        return
      }
      this.$emit('send', { ...this.model })
    },
    getInputValue (event) {
      const setInput = {
        cpf: (value) => this.setCpf(value),
        msisdn: (value) => this.setMsisdn(value)
      }

      if (event.valid) {
        setInput[event.name](event.value)
      }
    },
    validationCpf (value) {
      return isValidCpf(onlyNumbers(value))
    },
    validationMsisdn (value) {
      return isValidPhone(onlyNumbers(value))
    },
    setCpf (cpf) {
      this.model.cpf = cpf
    },
    setMsisdn (msisdn) {
      this.model.msisdn = msisdn
    },
    setPreFilled (value) {
      this.preFill = value
    },
    onBlur (key) {
      this.touched[key] = true
    },
    onPrepareData () {
      const msisdn = this.$route.query[SMS_MSISDN_KEY]
      const offerId = this.$route.query[SMS_OFFER_KEY]
      const cpf = this.$route.query[CPF_KEY]
      if (msisdn && cpf && offerId) {
        this.setMsisdn(msisdn)
        this.setCpf(cpf)
        this.setPreFilled(true)
        setOffer(offerId)
        this.setShowBackButton(false)
        this.send()
      }

      if (this.$route.params.televendasdata !== undefined) {
        const decodedValue = Buffer.from('' + this.$route.params.televendasdata, 'base64').toString('utf8')
        const [msisdn, cpf, plan, televendasId] = decodedValue.split(';')
        this.setMsisdn(msisdn)
        this.setCpf(cpf)
        this.setPreFilled(true)
        setOffer(plan)
        setChannel('TELEVENDAS')
        if (televendasId !== undefined) {
          setTelevendasId(televendasId)
        }
        this.storeIsTelevendas(true)
        this.setShowBackButton(false)
      }
    }
  }
}
</script>
